import styled from 'styled-components';
import { COLOR } from '@src/styles/color';

export const StyledPersonalInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  background-color: ${COLOR.charcoal};
  border-radius: 8px;
  padding: 16px;
  .input-error {
    color: ${COLOR.functionalRed.default};
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: -0.4px;
  }
  .personal-info-input {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    gap: 8px;
    flex: 1;
    width: 100%;

    .personal-info-input-item {
      height: 44px;
      flex: 1;
      .MuiOutlinedInput-root {
        flex: 1;
        width: 100%;
        background-color: ${COLOR.white};
        border-radius: 8px;
        font-size: 14px;
        line-height: 20px;
        font-weight: 400;
        color: ${COLOR.darkGray};
        outline: none;
      }
    }
    .identity-upload-container {
      width: 100%;
      border-radius: 8px;
      .identity-upload-icon {
        border-radius: 8px;
        border: 1px dashed ${COLOR.secondary[16]};
        background: ${COLOR.backgroundDefault};
        height: 56px;
        width: 56px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
      }
      .identity-upload-error {
        border: 1px dashed ${COLOR.functionalRed.default};
      }
      .identity-upload-file {
        width: 120px;
        height: 82px;
        display: flex;
        cursor: pointer;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 4px;
        img {
          width: 120px;
          height: 82px;
          border-radius: 8px;
        }
      }
      .identity-uploaded {
        width: 120px;
        height: 82px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 4px;
      }
    }
  }
  .digital-signature-container {
    .input-label {
      line-height: 24px;
    }
    .digital-signature-content {
      display: flex;
      flex-direction: column;
      gap: 16px;
      background-color: ${COLOR.white};
      border-radius: 12px;
      border: 1px solid ${COLOR.indigo[16]};
      height: 200px;
      align-items: center;
      justify-content: center;
    }
    .error-signature {
      border: 1px solid ${COLOR.functionalRed.default};
    }
  }
`;
